import { Injectable } from '@angular/core';

// TODO This class can be a regular class with static helper methods. Belongs in a helpers/ folder.
@Injectable()
export class UtilService {
  static MEASUREMENT_TYPE_ENERGY = 'energy';
  static MEASUREMENT_TYPE_POWER = 'power';
  static MEASUREMENT_TYPE_AIRCON_STATUS = 'aircon_status';
  static MEASUREMENT_TYPE_AIRCON_SETPOINT = 'aircon_setpoint';
  static MEASUREMENT_TYPE_AMBIENT_HUMIDITY = 'ambient_humidity';
  static MEASUREMENT_TYPE_AMBIENT_TEMPERATURE = 'ambient_temperature';
  static MEASUREMENT_TYPE_OCCUPANCY = 'occupancy';
  static MEASUREMENT_TYPE_DOOR_SENSOR = 'door_sensor';

  static DEVICE_TYPE_ENERGY = 'energy';
  static DEVICE_TYPE_AIRCON = 'aircon';
  static DEVICE_TYPE_DOOR = 'door';
  static DEVICE_TYPE_OCCUPANCY = 'occupancy';
  static DEVICE_TYPE_PIPE_MONITOR = 'pipe_temp'; // refers to stream-0 of pipe monitor
  static DEVICE_TYPE_FLOW_METER = 'flow_meter';
  static DEVICE_TYPE_VALVE = 'valve';

  public timestampFormatter(timestamp) {
    return timestamp * 1000; // milliseconds for highcharts
  }

  sortByKey(array, key) {
    return array.sort((a, b) => {
      {
        const reA = /[^a-zA-Z]/g;
        const reN = /[^0-9]/g;
        const aA = a[key].replace(reA, '');
        const bA = b[key].replace(reA, '');
        if (aA === bA) {
          const aN = parseInt(a[key].replace(reN, ''), 10);
          const bN = parseInt(b[key].replace(reN, ''), 10);
          return aN === bN ? 0 : aN > bN ? 1 : -1;
        } else {
          return aA > bA ? 1 : -1;
        }
      }
    });
  }

  extractCommonArrayElementsById(arr1, arr2) {
    const arr = [arr1, arr2];

    return arr.shift().filter(y => arr.every(x => x.some(j => j.id === y.location_id)));
  }

  public formatStreamDataValues(values, measurementType: string) {
    const myData = [];
    if (!values) {
      return myData;
    }

    values.forEach(value => {
      const formattedTimestamp = this.timestampFormatter(value.timestamp);

      switch (measurementType) {
        case UtilService.MEASUREMENT_TYPE_ENERGY:
          myData.push([formattedTimestamp, +value.consumed_energy.toFixed(2)]);
          break;
        case UtilService.MEASUREMENT_TYPE_POWER:
          myData.push([formattedTimestamp, +(value.power / 1000).toFixed(2)]);
          break;
        case UtilService.MEASUREMENT_TYPE_AIRCON_STATUS:
          myData.push([formattedTimestamp, value.powered ? 1 : 0]);
          break;
        case UtilService.MEASUREMENT_TYPE_AIRCON_SETPOINT:
          myData.push([formattedTimestamp, value.temperature_set]);
          break;
        case UtilService.MEASUREMENT_TYPE_AMBIENT_HUMIDITY:
          myData.push([formattedTimestamp, value.humidity_ambient]);
          break;
        case UtilService.MEASUREMENT_TYPE_AMBIENT_TEMPERATURE:
          myData.push([formattedTimestamp, value.temperature_ambient]);
          break;
        case UtilService.MEASUREMENT_TYPE_OCCUPANCY:
          myData.push([formattedTimestamp, value.occupancy ? 1 : 0]);
          break;
        case UtilService.MEASUREMENT_TYPE_DOOR_SENSOR:
          myData.push([formattedTimestamp, value.open ? 1 : 0]);
          break;
      }
    });

    return myData;
  }

  addRelevantIcons(array, key) {
    array.forEach(item => {
      if (item[key].indexOf('AC') >= 0) {
        item['icon'] = 'glyphicons-temperature-low';
      } else if (item[key].indexOf('Heater') >= 0) {
        item['icon'] = 'glyphicons-temperature-high';
      } else {
        item['icon'] = 'glyphicons-engineering-networks';
      }
    });
    return array;
  }
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/core/util.service.ts